"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavLogin = _interopRequireDefault(require("./NavLogin"));

var _ButtonUser = _interopRequireDefault(require("./ButtonUser"));

var _UserDropdown = _interopRequireDefault(require("./UserDropdown"));

var _UserInfo = _interopRequireDefault(require("./UserInfo"));

var _UserAppInfo = _interopRequireDefault(require("./UserAppInfo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const UserButtonRef = _react.default.forwardRef((props, ref) => {
  return _react.default.createElement(_ButtonUser.default, _extends({}, props, {
    forwardedRef: ref
  }));
});

const NavUser = (_ref) => {
  let className = _ref.className,
      app = _ref.app,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? undefined : _ref$user,
      onLogin = _ref.onLogin,
      onLogout = _ref.onLogout,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "app", "user", "onLogin", "onLogout"]);

  const _React$useState = _react.default.useState(false),
        expanded = _React$useState[0],
        setExpanded = _React$useState[1];

  const anchorRef = _react.default.useRef(null);

  const handleToggle = event => {
    setExpanded(prevExpanded => !prevExpanded);
  };

  const handleCollapse = () => {
    setExpanded(false);
  };

  const handleLogout = () => {
    setExpanded(false);
    onLogout && onLogout();
  };

  if (!user || !user.uniqueId) {
    return _react.default.createElement(_NavLogin.default, {
      onLogin: onLogin
    });
  }

  return _react.default.createElement("nav", {
    className: className
  }, _react.default.createElement(UserButtonRef, _extends({}, user, {
    onClick: handleToggle,
    expanded: expanded,
    ref: anchorRef
  })), _react.default.createElement(_UserDropdown.default, {
    expanded: expanded,
    anchorEl: anchorRef.current,
    arrowRef: anchorRef,
    onCollapse: handleCollapse
  }, _react.default.createElement(_UserInfo.default, user), _react.default.createElement(_UserAppInfo.default, _extends({}, app, {
    onLogout: handleLogout
  }))));
};

NavUser.propTypes = process.env.NODE_ENV !== "production" ? {
  app: _propTypes.default.node,
  user: _propTypes.default.node,
  onLogin: _propTypes.default.func,
  onLogout: _propTypes.default.func
} : {};
var _default = NavUser;
exports.default = _default;
module.exports = exports.default;